import { Model as u } from "../../../../model.js";
import { getDateTime as r, formatCurrency as i, centsToNumber as m } from "../../../../../../utils.js";
var s = /* @__PURE__ */ ((e) => (e[e.CREATE = 1] = "CREATE", e[e.UPDATE_BALANCE = 2] = "UPDATE_BALANCE", e[e.DEACTIVATE = 3] = "DEACTIVATE", e))(s || {});
class l extends u {
  constructor(t) {
    super(), this.id = t.id, this.timestamp = t.timestamp, this.value = t.value, this.balance = t.balance, this.action = t.action, this.configuration = t.configuration, this.status = t.status, this.order = t.order, this.executedBy = t.executedBy, this.notes = t.notes;
  }
  getFormattedTimestamp() {
    return r(this.timestamp);
  }
  getFormattedValue(t) {
    return i(m(this.value), t);
  }
  getFormattedBalance(t) {
    return i(m(this.balance), t);
  }
}
export {
  s as CashbackRecordAction,
  l as CashbackRecordModel
};
//# sourceMappingURL=cashbackRecord.model.js.map
